import { render, staticRenderFns } from "./ReportDeskExportedReports.vue?vue&type=template&id=23c60061"
import script from "./ReportDeskExportedReports.vue?vue&type=script&lang=js"
export * from "./ReportDeskExportedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports